import { render, staticRenderFns } from "./ssr-detail-ss.vue?vue&type=template&id=5ab6c3b2&scoped=true"
import script from "./ssr-detail-ss.vue?vue&type=script&lang=js"
export * from "./ssr-detail-ss.vue?vue&type=script&lang=js"
import style0 from "./ssr-detail-ss.vue?vue&type=style&index=0&id=5ab6c3b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab6c3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab6c3b2')) {
      api.createRecord('5ab6c3b2', component.options)
    } else {
      api.reload('5ab6c3b2', component.options)
    }
    module.hot.accept("./ssr-detail-ss.vue?vue&type=template&id=5ab6c3b2&scoped=true", function () {
      api.rerender('5ab6c3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/ssr-detail-ss.vue"
export default component.exports